import { Component, OnInit } from '@angular/core';
import { ToastService } from 'src/app/core/toast.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Produto } from 'src/app/model/produto';
import { ProdutoapiService } from 'src/app/dao/api_produto.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-alteracao-lote',
  templateUrl: './alteracao-lote.page.html',
  styleUrls: ['./alteracao-lote.page.scss'],
  providers: [MessageService, ConfirmationService]
})
export class AlteracaoLotePage implements OnInit {

  freteDialog: boolean;

  prods: Produto[];

  prod: Produto;

  selectedfretes: Produto[];

  submitted: boolean;

  novoValor: number;

  novoValorPorcentagem: number;

  acresBool: boolean;

  ativos;

  idCat;

  // tslint:disable-next-line: max-line-length
  constructor(private router: Router, private route: ActivatedRoute, private produtoService: ProdutoapiService, private toast: ToastService, private confirmationService: ConfirmationService) {}

  async ngOnInit() {
    this.prod = new Produto();
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
    this.produtoService.GetByCat(idParam).then(data => this.prods = data);
    const result = await this.produtoService.GetByCat(idParam);
    this.idCat = idParam;
  }
    this.ativos = [
      {nome:'ATIVO', valor: 1},
      {nome:'INATIVO', valor: 0}
    ]
    this.carregarAtivos();
  }


  carregarAtivos() {
        this.ativos = this.ativos.map(c => {
          return ({ label: c.nome, value: c.valor });
          // tslint:disable-next-line: align
        });
  }

  openNew() {
    // tslint:disable-next-line: new-parens
    this.prod = {};
    this.submitted = false;
    this.freteDialog = true;
  }


  zerarCampos(campo){
    console.log(campo.name);
    switch(campo.name){
      case "novoValor":
        this.novoValorPorcentagem = null;
      break;
      case "novoValorPorcentagem":
        this.novoValor = null;
      break;
    }
  }

  alterarValores() {
    if(this.novoValor >= 0 || (this.novoValorPorcentagem >=0 || this.novoValorPorcentagem <=0)){
  
      let texto;
      let porcentagem = false;
      if(this.novoValor != null){
        console.log("Entrou no if valor normal");
        texto = "Deseja mesmo alterar o valor dos produtos selecionados para R$"+this.novoValor.toFixed(2).replace('.', ',')+" ?";
      }

      if(this.novoValorPorcentagem != null){
        console.log("Entrou no if porcentagem");
        porcentagem = true;
        if(this.acresBool){
          texto = "Deseja mesmo alterar o valor dos produtos selecionados para +"+this.novoValorPorcentagem+"% do valor?";
        }else{
          texto = "Deseja mesmo alterar o valor dos produtos selecionados para -"+this.novoValorPorcentagem+"% do valor?";
        }
      }

      this.confirmationService.confirm({
      message: texto,
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        //this.prods = this.prods.filter(val => !this.selectedfretes.includes(val));
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.selectedfretes.length; i++) {
          if(porcentagem){
            if(this.acresBool){
              this.selectedfretes[i].valor = (this.selectedfretes[i].valor) * (this.novoValorPorcentagem / 100) + (this.selectedfretes[i].valor);
            }else{
              this.selectedfretes[i].valor = (this.selectedfretes[i].valor) - (this.selectedfretes[i].valor) * (this.novoValorPorcentagem / 100);
            }

          }else{
            this.selectedfretes[i].valor = this.novoValor;
          }
          if(this.selectedfretes[i].valor >= 0){
            console.log(this.selectedfretes[i]);
            const result = this.produtoService.atualizar(this.selectedfretes[i]);
            console.log(result);
          }else{
            this.toast.showSucess('O valor deve ser maior que zero!');
          }
          
        }
        this.selectedfretes = undefined;
        this.toast.showSucess('Valores atualizados com sucesso!');
        //this.produtoService.GetByCat(this.idCat).then(data => this.prods = data);
      }
    });

  }else{
    this.toast.showError("Preencha um campo de valor!")
      return console.log("else");
      
  }
  }

  editfrete(prod: Produto) {
    this.prod = {...prod};
    this.freteDialog = true;
  }

  hideDialog() {
    this.freteDialog = false;
    this.submitted = false;
  }
  
}
